import { render, staticRenderFns } from "./AdminNotifications.vue?vue&type=template&id=4789dad2&scoped=true"
import script from "./AdminNotifications.vue?vue&type=script&lang=js"
export * from "./AdminNotifications.vue?vue&type=script&lang=js"
import style0 from "./AdminNotifications.vue?vue&type=style&index=0&id=4789dad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4789dad2",
  null
  
)

export default component.exports